import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment/src/moment'
@Pipe({
    name: 'dateformat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {

  transform(value: any, args?: any): string {
    return moment(value).format('MMM DD, YYYY');
  }

}
